import React from 'react';

import { Typography } from '@material-ui/core';

import { logError } from 'utils/reporter';

import { fromError } from 'stacktrace-js';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        var callback = function(stackframes) {
            var stringifiedStack = stackframes
                .map(function(sf) {
                    return sf.toString();
                })
                .join('\n');
            logError({
                message: error.message,
                name: error.name,
                stack: stringifiedStack
            });
        };
        var errback = function(err) {
            console.log(err.message);
        };
        fromError(error)
            .then(callback)
            .catch(errback);
        // TODO: You can also log the error to an error reporting service
        //logErrorToMyService(error, info);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={{ padding: 8, paddingTop: '40vh' }}>
                    <Typography align="center" variant="h4" style={{ marginBottom: 8 }}>
                        Something went wrong!
                    </Typography>
                    <Typography align="center" variant="subtitle1">
                        We apologize for the inconvenience. Our team has been automatically notified of the error.
                    </Typography>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
